import React from 'react';
import { useSelector } from 'react-redux';
import { Field, Message, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent, WorksheetResultsSection, WorksheetsResultsMessagesSection } from '../../../Core';
import { MddChartSection } from '../../Shared';

const contextCaptions = [
  {
    path: `data.Preparation.SpecificGravityCoarse.AssociatedOversizeMoisture.MeasuredTest.DryingTray`,
    caption: 'Coarse Material Moisture Content',
  },
  {
    path: `data.Preparation.AssociatedFineMoisture.MeasuredTest.DryingTray`,
    caption: 'Passing Material Moisture Content',
  },
  { path: `data.Preparation.AssociatedOversizeDetermination.MeasuredTest.CoarseMaterial`, caption: 'Coarse Material' },
  {
    path: `data.Preparation.AssociatedOversizeDetermination.MeasuredTest.PassingMaterial`,
    caption: 'Passing Material',
  },
  { path: `data.Preparation.MinimumOversizeForCorrection`, caption: 'Oversize Determination' },
  { path: `data.TestPortions`, caption: 'Test Portions' },
  { path: `data.Preparation.ScreeningASTM`, caption: 'Oversize Determination' },
];
const excludeMessagePaths = [`data.Results`];

let ResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const correctionRequired = (useSelector(createWorksheetSelector!('Preparation.OversizeCorrectionRequired')) ??
    false) as boolean;
  return (
    <WorksheetResultsSection heading="Results">
      <MddChartSection />
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} excludeMessagePaths={excludeMessagePaths} />
      <ListFieldSection heading="Laboratory Results">
        <Field label="Maximum Dry Density" input={<TextOutput />} name="Results.MaximumDryDensity" emph />
        <Field label="Optimum Moisture Content (%)" input={<TextOutput />} name="Results.OptimumMoistureContent" emph />
      </ListFieldSection>
      {correctionRequired ? (
        <ListFieldSection heading="Corrected for Oversize">
          <Field
            label="Adjusted Maximum Dry Density"
            input={<TextOutput />}
            name="Results.AdjustedMaximumDryDensity"
            emph
          />
          <Field
            label="Adjusted Optimum Moisture Content (%)"
            input={<TextOutput />}
            name="Results.AdjustedOptimumMoistureContent"
            emph
          />
        </ListFieldSection>
      ) : (
        <Message border={false}>Compaction data not corrected for oversize material</Message>
      )}
      <ListFieldSection name="Results" /* for results messages */ />
    </WorksheetResultsSection>
  );
};

ResultsSection = withInjectedProps(ResultsSection);

export { ResultsSection };
export default ResultsSection;
